<template>
    <v-app id="mpe">
        <app-drawer></app-drawer>
        <app-toolbar></app-toolbar>
        <v-content>
            <div class="page-wrapper">
                <keep-alive>
                    <router-view></router-view>
                </keep-alive>
            </div>
        </v-content>
        <v-footer height="auto" color="grey lighten-3" app class="pa-2">
            <span class="text--primary headline hidden-md-and-down">&copy; <a href="https://multipartseurope.com/" target="_blank">Multiparts Europe</a> {{ new Date().getFullYear() }}</span>
            <span class="ml-2">Stock numbers correct as of {{ $moment().hour(9).minute(30).second(0).tz('Europe/London').toString() }}</span>
            <v-spacer></v-spacer>
            <img class="hidden-sm-and-down" src="/images/footer-logo-v3.png">
        </v-footer>
        <vue-snotify></vue-snotify>
    </v-app>
</template>

<script>
// import AppEvents from './events'

import AppToolbar from './components/AppToolbar'
import AppDrawer from './components/AppDrawer'
import { loadLanguageAsync } from '@/localization'
import { mapActions, mapGetters } from 'vuex'

export default {
  components: {
    AppToolbar,
    AppDrawer
  },
  props: {
    source: String
  },
  data: () => ({
    drawer: null
  }),
  created () {
  },
  mounted () {
    let _lang = this.lang || 'en'
    loadLanguageAsync(_lang).then(() => {
      this.$log.debug(`Language Changed: ${_lang}`)
      this.setLang({ lang: _lang })
    })
  },
  computed: {
    ...mapGetters(
      'localisation', {
        lang: 'lang'
      }
    ),
    ...mapGetters(
      'auth', {
        logout: 'logout'
      }
    )
  },
  methods: {
    ...mapActions(
      'localisation', {
        setLang: 'setLang'
      }
    )
  }
}
</script>

<style lang="stylus" scoped>
    .page-wrapper
        min-height:calc(100vh - 64px - 50px - 81px );
</style>
